import React from 'react';

export default function AudioRecorder({ width = 32, height = 32, fill = '#FE5442', ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clip-path="url(#clip0_4196_118901)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M32.0002 7.00438C32.0002 5.14699 31.2627 3.36621 29.9501 2.05282C28.637 0.74006 26.857 0.00195312 25.0005 0.00195312H7.00168C5.1452 0.00195312 3.36512 0.74006 2.052 2.05282C0.739451 3.36621 0.00195312 5.14699 0.00195312 7.00438V25.0101C0.00195312 26.8675 0.739451 28.6483 2.052 29.9616C3.36512 31.2744 5.1452 32.0125 7.00168 32.0125H25.0005C26.857 32.0125 28.637 31.2744 29.9501 29.9616C31.2627 28.6483 32.0002 26.8675 32.0002 25.0101V7.00438Z"
          fill={fill}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M21.984 8.44971C22.203 8.74271 22.333 9.10571 22.333 9.49871C22.333 9.89271 22.203 10.2557 21.984 10.5477C21.735 10.8787 21.802 11.3497 22.133 11.5987C22.464 11.8467 22.934 11.7797 23.183 11.4487C23.591 10.9057 23.833 10.2307 23.833 9.49871C23.833 8.76771 23.591 8.09271 23.183 7.54971C22.934 7.21871 22.464 7.15171 22.133 7.39971C21.802 7.64871 21.735 8.11971 21.984 8.44971Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.81699 7.54971C8.40899 8.09271 8.16699 8.76771 8.16699 9.49871C8.16699 10.2307 8.40899 10.9057 8.81699 11.4487C9.06599 11.7797 9.53599 11.8467 9.86699 11.5987C10.198 11.3497 10.265 10.8787 10.016 10.5477C9.79699 10.2557 9.66699 9.89271 9.66699 9.49871C9.66699 9.10571 9.79699 8.74271 10.016 8.44971C10.265 8.11971 10.198 7.64871 9.86699 7.39971C9.53599 7.15171 9.06599 7.21871 8.81699 7.54971Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M24.567 7.44971C24.996 8.02171 25.25 8.73071 25.25 9.49971C25.25 10.2687 24.996 10.9777 24.567 11.5497C24.318 11.8797 24.385 12.3507 24.716 12.5997C25.047 12.8477 25.517 12.7807 25.766 12.4497C26.384 11.6277 26.75 10.6067 26.75 9.49971C26.75 8.39271 26.384 7.37171 25.766 6.54971C25.517 6.21871 25.047 6.15171 24.716 6.39971C24.385 6.64871 24.318 7.11971 24.567 7.44971Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.234 6.54971C5.616 7.37171 5.25 8.39271 5.25 9.49971C5.25 10.6067 5.616 11.6277 6.234 12.4497C6.483 12.7807 6.953 12.8477 7.284 12.5997C7.615 12.3507 7.682 11.8797 7.433 11.5497C7.004 10.9777 6.75 10.2687 6.75 9.49971C6.75 8.73071 7.004 8.02171 7.433 7.44971C7.682 7.11971 7.615 6.64871 7.284 6.39971C6.953 6.15171 6.483 6.21871 6.234 6.54971Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16 5.25C13.365 5.25 11.25 7.286 11.25 9.769V16.231C11.25 18.714 13.365 20.75 16 20.75C18.635 20.75 20.75 18.714 20.75 16.231V9.769C20.75 7.286 18.635 5.25 16 5.25ZM16 19.25C14.217 19.25 12.75 17.911 12.75 16.231V9.769C12.75 8.089 14.217 6.75 16 6.75C17.783 6.75 19.25 8.089 19.25 9.769V16.231C19.25 17.911 17.783 19.25 16 19.25Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16 21.75C12.856 21.75 10.25 19.661 10.25 17V15C10.25 14.586 9.914 14.25 9.5 14.25C9.086 14.25 8.75 14.586 8.75 15V17C8.75 20.415 11.964 23.25 16 23.25C20.036 23.25 23.25 20.415 23.25 17V15C23.25 14.586 22.914 14.25 22.5 14.25C22.086 14.25 21.75 14.586 21.75 15V17C21.75 19.661 19.144 21.75 16 21.75Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.25 22.5V26C15.25 26.414 15.586 26.75 16 26.75C16.414 26.75 16.75 26.414 16.75 26V22.5C16.75 22.086 16.414 21.75 16 21.75C15.586 21.75 15.25 22.086 15.25 22.5Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M19 25.25H13C12.586 25.25 12.25 25.586 12.25 26C12.25 26.414 12.586 26.75 13 26.75H19C19.414 26.75 19.75 26.414 19.75 26C19.75 25.586 19.414 25.25 19 25.25Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_4196_118901">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
